import { BbocTheme } from 'styled-components';
import { errorRed, okGreen2, superLightGreyColour, warningYellow2 } from '../cssConstants';

// When editing this theme, please keep styled.d.ts up-to-date

export const greyTheme: BbocTheme = {
	progressColour: superLightGreyColour
};

export const redTheme: BbocTheme = {
	progressColour: errorRed
};

export const yellowTheme: BbocTheme = {
	progressColour: warningYellow2
};

export const greenTheme: BbocTheme = {
	progressColour: okGreen2
};
